const basePlaygroundRoute = (studentId: string, linkBase: string) => {
  if (linkBase === 'teacher') return `/${linkBase}/playground`;
  return `/${linkBase}/${studentId}/playground`;
};

export default basePlaygroundRoute;
